<div #inputField
     [contenteditable]="true"
     [(ngModel)]="value"
     [attr.placeholder]="placeholder"
     (input)="handleInput()"
     (blur)="handleBlur()"
     class="brn-input"
     [ngClass]="inline ? 'inline' : ''"
></div>
